import type {
  ThemeOptions,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants
} from '@mui/material/styles';

import type { Theme } from '@ui/ThemeRegistry/theme.types';

const defaultProps: ComponentsProps['Blog'] = {};

const styleOverrides: ComponentsOverrides<Theme>['Blog'] = {
  root: ({ theme, ownerState }) => ({
    ...theme.mixins.applyBackgroundColor({
      ownerState: { ...ownerState, backgroundColor: 'surface' },
      theme
    }),
    'containerType': 'inline-size',
    'position': 'relative',
    'width': '100%',
    'display': 'flex',
    'flexDirection': 'column',

    '& > *:not([class*="Hero-root"])': {
      paddingTop: 'var(--section-padding)',
      paddingBottom: 'var(--section-padding)'
    }
  }),

  contentOuterGrid: ({ theme, ownerState }) => ({
    paddingTop: 'calc(var(--section-padding) / 2) !important',
    paddingBottom: 'calc(var(--section-padding) / 2) !important'
  }),

  featuredMediaWrap: ({ theme, ownerState }) => ({
    'display': 'flex',
    'justifyContent': 'center',
    'gridColumn': 'start/end',

    [theme.containerBreakpoints.up('lg')]: {
      gridColumn: 'two-start/eleven-end !important'
    },

    '& :is(video, img, svg, picture)': {
      borderRadius: theme.spacing(3),

      paddingBottom: 'var(--grid-gap)'
    }
  }),

  shareLinksWrap: {
    gridColumn: 'full-start/full-end'
  },

  detailsLabel: {
    '&': {
      paddingBottom: 'var(--grid-gap)'
    }
  },

  bodyHeader: {
    '&:not(:first-of-type)': {
      paddingTop: 'var(--grid-gap)',
      marginTop: 'var(--grid-gap)',
      borderTop: 'solid',
      borderTopWidth: '1px'
    }
  },

  contentWrap: ({ theme }) => ({
    gridColumn: 'start/end',

    [theme.containerBreakpoints.up('lg')]: {
      gridColumn: 'two-start/eleven-end !important'
    },

    img: {
      padding: 'var(--grid-gap) 0',

      [theme.containerBreakpoints.up('md')]: {
        padding: 'var(--section-padding) 0',
        maxWidth: '75%',
        margin: '0 auto'
      }
    }
  })
};

const createVariants = (_theme: Theme): ComponentsVariants['Blog'] => [];

export const blogTheme = (theme: Theme): ThemeOptions => ({
  components: {
    Blog: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});

export default blogTheme;
